module.exports = __webpack_public_path__ + "img/add.1c6453eb.svg";